module.exports = __webpack_public_path__ + "static/img/play-store.9492d0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-store.png
// module id = 6hIX
// module chunks = 0